<template>
  <div class="dialog-wrap">
    <el-dialog title="调剂记录" :close-on-click-modal="false" :visible.sync="dialogVisible" @close="handleClose" width="955px">
      <el-table :data="tableData" border>
        <el-table-column prop="id" label="ID" align="center" width="70" fixed="left">
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" align="center" width="130" fixed="left">
        </el-table-column>
        <el-table-column prop="college_name" label="院校名称" align="center" width="180">
        </el-table-column>
        <el-table-column prop="id" label="专业名称" align="center" width="210">
          <template slot-scope="scope">
            <span>{{`(${scope.row.major_code})${scope.row.major_name}`}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="academy_name" label="学院名称" align="center" width="180" show-overflow-tooltip>
        </el-table-column>
        <!--     <el-table-column prop="academy_name" label="招生类型" align="center" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.enrol_type==1?'全日制':'非全日制'}}</span>
            </template>
          </el-table-column> -->
        <el-table-column prop="first_college_name" label="一志愿院校" align="center" width="180">
        </el-table-column>
        <el-table-column prop="id" label="一志愿专业" align="center" width="210">
          <template slot-scope="scope">
            <span>{{`(${scope.row.first_major_code})${scope.row.first_major_name}`}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="初试总分" align="center" width="100">
          <template slot-scope="scope">
            <span>{{scope.row.first_score+'分'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contact_name" label="联系老师" align="center" width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="contact_mobile" label="联系方式" align="center" width="130">
        </el-table-column>
        <el-table-column prop="contact_time_period" label="可联系时间段" align="center" width="130">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="120" align="center">
          <template slot-scope="scope">
            <span>{{  $moment(scope.row.create_time).format("YYYY-MM-DD") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="联系状态" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-tag type="success" size="small" v-if="scope.row.status==1">已联系</el-tag>
            <el-tag type="info" size="small" v-else>未联系</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { adjustHelplist } from "@/api/adjust";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      tableData: [],
      query: {
        isPaging: 0,
        uid: this.id,
        is_user_only: 0,
      },
      pageTotal: 0,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    id(val) {
      this.query.uid = val
      this.fetchAdjustHelplist(this.query)
    },
  },
  created() {

  },
  methods: {
    fetchAdjustHelplist() {
      adjustHelplist(this.query).then(res => {
        this.tableData = res.list || []
        this.pageTotal = res.count
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
